import lang from '../lang';
import crypto from 'crypto';
import JSZip from 'jszip';

const VCAPP_URL = 'https://lightcrm.vashcenter.gr';
const XHR_CREDS = 'b3JkZXJGb3JtOll5NFRnSjlQY1RrVENLOWNFUU5vSGJibg==';
const SECRET = 'apw4y7BTHne3xJ7u';
const MAX_FILES_SIZE = 5000000; // 5 MB
export const ADMIN_EMAIL = '84258a0830ac7756ec233189057ec45914a716e9841762858dd53c5897eb53c4';
export const CUSTOMER_EMAIL = '84258a0830ac7756ec233189057ec4592a02e3b302b6d7194a44deab403d06eaaff9fab18b2b48d6284e388653ba5793';

export const ALLOWED_FILES = [
    "text/plain",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];

const DOC_TYPES = ['passport', 'residence', 'other'];

const helpers = {
    encrypt: function (text) {
        let cipher = crypto.createCipher('aes-128-ecb', SECRET);
        let crypted = cipher.update(text, 'utf8', 'hex');
        crypted += cipher.final('hex');
        return crypted;
    },

    ifkeyCodeAllowed: (evt, regex, omitEvts = null, addEvts = null) => {
        var keyCode = evt.which || evt.keyCode || 0;
        var allowedCodes = [8, 37, 38, 39, 40];
        var metaAllowedCodes = [67, 65, 86, 90];

        if (omitEvts !== null) {
            for (let omEvt of omitEvts) {
                let index = allowedCodes.indexOf(omEvt);
                if (index !== -1)
                    allowedCodes.splice(index, 1);
            }
        }

        if (addEvts !== null) {
            for (let aEvt of addEvts) {
                allowedCodes.push(aEvt)
            }
        }

        return !(!regex.test(evt.key)
            && allowedCodes.indexOf(keyCode) === -1
            && !(evt.metaKey === true && metaAllowedCodes.indexOf(keyCode) !== -1))
    },

    capitalize: word => {
        return word.substr(0, 1).toUpperCase() + word.substr(1, word.length).toLowerCase();
    },

    emailValidator: email => {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    getCurrentDate: () => {
        let now = new Date();
        return  ('0' + now.getDate()).slice(-2) + '/' + ('0' + (now.getMonth()+1)).slice(-2) + '/' + now.getFullYear();
    },

    /**
     * Determines human readable file size
     * @param sizeBytes size in bytes
     * @return {string} file size
     */
    getNaturalFileSize: function(sizeBytes) {
        let filesSize = sizeBytes;

        for (let aSizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], aSize = 0, nApprox = sizeBytes / 1024; nApprox > 1; nApprox /= 1024, aSize++)
            filesSize = nApprox.toFixed(1) + ' ' + aSizes[aSize];

        return filesSize === sizeBytes ? filesSize + ' KB' : filesSize;
    },

    /**
     * @param files object
     * @param zipFinal zip object for current order files
     * @param zipGlobal zip object for all the order files
     * @param orderName current order name
     * @param langCode language code
     * @return {object} {filesSize: size, filesCount: length, zipFinal: zipObj, errs: []}
     */
    handleFiles: (files, zipfileSize, zipFinal, zipGlobal, orderName, lang) => {
        let docType = DOC_TYPES.indexOf(orderName) !== -1 ? orderName : DOC_TYPES[DOC_TYPES.length-1];
        let sizeBytes = 0;
        let errs = {
            fileType: [],
            fileSize: []
        };
        let res = {
            filesSize: 0,
            filesCount: 0,
            zipFinal: zipFinal,
            errs: []
        };

        for (let file of files) {
            let fname = file.name;
            let err = false;

            if (ALLOWED_FILES.indexOf(file.type) === -1) {
                errs.fileType.push(fname);
                err = true;
            }

            if (MAX_FILES_SIZE < (file.size+zipfileSize) || (sizeBytes+file.size) > MAX_FILES_SIZE) {
                errs.fileSize.push(fname);
                err = true;
            }

            if (!err && Object.keys(zipFinal.files).indexOf(fname) === -1) {
                sizeBytes += file.size;
                res.filesSize = sizeBytes;
                res.filesCount++;
                res.zipFinal = zipFinal.file((docType+'/'+fname), file, {compression: 'DEFLATE'});
                zipGlobal.file((docType+'/'+fname), file, {compression: 'DEFLATE'});
            }
        }

        let names = Array.from(new Set(errs.fileSize.concat(errs.fileType)));

        if (names.length) {
            res.errs.push((names.length > 1 ? lang.wrong_files : lang.wrong_file) + names.join(', '));

            if (errs.fileType.length)
                res.errs.push(lang.allowed_files);

            if (errs.fileSize.length)
                res.errs.push(lang.max_file_size);
        }

        return res;
    },

    removeFromAllFiles: async (allFiles, zipBlob) => {
        let zipObj = new JSZip();
        let dirname = '', allFilesLen = 0;

        await zipObj.loadAsync(zipBlob);

        zipObj.forEach((path, file) => {
            if (!file.dir)
                allFiles.remove(path);
            else
                dirname = path.substr(0, path.length-1);
        });

        allFiles.forEach(path => {
            if (path.startsWith(dirname))
                ++allFilesLen;
        });

        if (allFilesLen === 1)
            allFiles.remove(dirname);
    },

    cookEmail: async (langCode, target, data) => {
        let langEmail = target === 'vashcenter' ? lang['ru'].message.email[target] : lang[langCode].message.email[target];
        let langOrder = target === 'vashcenter' ? lang['ru'].service.elem : lang[langCode].service.elem;
        let {creds, orders, files, comment, orderId} = data;
        let subject = '';
        let body = '';
        let attachment = null;

        switch (target) {
            case 'customer':
                subject = langEmail.subject;
                body = langEmail.body
                    .replace(/\$firstname/g, creds.firstname)
                    .replace(/\$lastname/g, creds.lastname)
                    .replace(/\$id/g, orderId);

                break;

            case 'vashcenter':
                let orderNames = orders.reduce((acc, val, i) => acc + (i === 0 ? '' : langOrder[val.name].label) + ', ', langOrder[orders[0].name].label).trim();

                subject = langEmail.subject
                    .replace(/\$lastname/g, creds.lastname)
                    .replace(/\$order/g, orderNames.substr(0, orderNames.length-1));

                body = '<b>ID</b>: $ID<br>';

                body += langEmail.body.creds
                    .replace(/\$firstname/g, creds.firstname)
                    .replace(/\$lastname/g, creds.lastname) + '<br>';

                body += langEmail.body.tel
                    .replace(/\$phoneHref/g, creds.phone.replace(/[^\d]/g, ''))
                    .replace(/\$phone/g, creds.phone)  + '<br>';

                body += langEmail.body.email.replace(/\$email/g, creds.email)  + '<br>';

                if (comment.length)
                    body += langEmail.body.comment.replace(/\$comment/g, comment) + '<br>';

                body += '<br>';

                if (orders.length) {
                    let filesCount = 0;

                    body += (orders.length > 1 ? langEmail.body.orders : langEmail.body.order);

                    body += (orders.length > 1 ? '<ol>' : '<ul>');

                    orders.forEach(order => {
                        let oDetails = typeof order.details.emailDetails !== 'object' ? order.details.emailDetails : Object.values(order.details.emailDetails).join('; ');
                        let oDeadline = order.hasOwnProperty('deadline') ? '<br>' + langEmail.body.deadline.replace(/\$deadline/g, order.deadline) : '';

                        body += '<li>' + oDetails.concat(oDeadline) + '</li>';

                        if (order.files !== null && typeof order.files !== 'undefined') {
                            ++filesCount;
                            attachment = order.files.zip;
                        }
                    });

                    body += (orders.length > 1 ? '</ol>' : '</ul>');

                    if (filesCount > 1)
                        attachment = await files.generateAsync({type: 'blob'});
                }

                break;

            default:
                console.error('Unknown email target');
                break;
        }

        let resObj = {subject: subject, body: body};

        if (target === 'vashcenter')
            resObj.attachment = attachment;

        return resObj;
    },

    cook4VCApp: ({creds, orders, files, comment}) => (
        {
            action: 'createRecord',
            id: null,
            fullName: {
                firstName: creds.firstname,
                lastName: creds.lastname
            },
            birthday: '1900-01-01',
            nationality: 'UA',
            tel: [creds.phone.replace(/[^\d]/g, '')],
            address: [],
            docType: ((zipObj) => {
                let docTypes = new Set();
                let resDocs = [];

                zipObj.forEach(path => {
                    path = path.substr(0, path.indexOf('/'));
                    docTypes.add(DOC_TYPES.indexOf(path) === -1 ? DOC_TYPES[DOC_TYPES.length-1] : path);
                });

                docTypes.forEach(val => {
                    resDocs.push({[val]: {files: true, number: null}});
                });

                return resDocs;
            })(files),
            orderCategory: ((orders) => {
                let orderDate = helpers.getCurrentDate().split('/').reverse().join('-');

                return orders.map(order => ({
                    [order.name]: {
                        order: order.name,
                        orderDate: orderDate,
                        orderDeadline: order.hasOwnProperty('deadline') ? order.deadline.split('/').reverse().join('-') : orderDate,
                        orderPaidSum: 0,
                        order2PaySum: 0
                    }
                }));
            })(orders),
            notes: 'Онлайн заказ' + (comment.length ? ' > Комментарий:<br>' + comment : '')
        }
    ),

    ajax: async (servlet, formData, callback) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.upload.onprogress = e => {
                if (typeof callback === 'function')
                    if (e.lengthComputable)
                        callback(Math.round(e.loaded / e.total * 100));
            };

            xhr.onload = () => xhr.status === 200 ? resolve(xhr.response) : reject(new Error('Bad response status: ' + xhr.status));
            xhr.onerror = () => reject(new Error('xhr error occurred'));
            xhr.ontimeout = () => reject(new Error('xhr timeout occurred'));

            xhr.open('POST', VCAPP_URL.concat(servlet), true);

            // xhr.timeout = 10000;
            xhr.withCredentials = true;
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.setRequestHeader('Authorization', 'Basic ' + XHR_CREDS);
            xhr.send(formData);
        });
    },

    genDetails: (obj) => {
        let details = {};

        for (let detail of obj)
            details[detail.value] = 'details' in detail ? detail.details : detail.label;

        return details;
    },

    findCert: (certs, name) => {
        for (let i = 0; i < certs.length; i++) {
            if (certs[i].value === name)
                return {pos: i, cert: certs[i]};
        }
    },

    findOptSelected: target => {
        for (let opt of target.options) {
            if (opt.selected) {
                return opt.dataset.code;
            }
        }
    },

    calcTotal: (obj1, obj2, deadline) => {
        let total = 0, totalTemp = [];
        let value = obj2.value;

        const addTotal = value => {
            if (!deadline)
                total += value;
            else {
                totalTemp.push(value);
                total = Math.round(totalTemp.reduce((acc, val) => (acc+val)) / totalTemp.length);
            }
        };

        Object.keys(obj1).forEach(k => {
            if (isNaN(obj2[k])) {
                if (typeof obj2[k] === 'string' && obj2[k].indexOf('-') !== -1) {
                    let tmp = Math.round((parseInt(obj2[k].split('-')[0], 10) + parseInt(obj2[k].split('-')[1], 10)) / 2);
                    addTotal(tmp);
                }
            } else
                addTotal(obj2[k]);
        });

        if (deadline) {
            total = total.toString();

            for (let num in value) {
                let nums = num.match(/\d/g);

                for(let digit of nums) {
                    if (total.endsWith(digit))
                        return total !== '0' ? total + ' ' + value[num] : null;
                }
            }

            return total;

        } else
            return !isNaN(total) && total !== 0 ? value + ' ' + total.toString() : null;
    },

    updateHeight: () => {
        let iframe = window.parent.document.getElementById('orderForm');
        let form = document.getElementsByTagName('form')[0];
        iframe.style.height = '' + (form.offsetHeight+40) + 'px';
    }

};

Object.freeze(helpers);

export default helpers;


// WEBPACK FOOTER //
// ./src/app/containers/helpers.js